
// Closure-free helpers at module scope (javascript:S7721). Prefixed to avoid colliding with other
// files in the same bundle.
function pshClearInputErrors(questionId) {
  $('#question-input-' + questionId + ' .input-error').removeClass('input-error');
}

// Sentry loads before this file in every index.html that includes it, but js/sentry.js is a bare
// Sentry.init() with no captureConsole integration, so a console call never reaches it on its own -
// see phReportWrongUserRetryProblem in portal_helper.js, same reasoning and same guard. Neither branch
// below is normal flow, and both leave the payer with a message and no highlighted box, so they have
// to be visible somewhere other than the payer's own console. The context argument matters: without a
// question id Sentry fingerprints every occurrence into one issue with nothing to reproduce from.
function pshReportHighlightProblem(message, context, error_) {
  console.error('rationale highlight: ' + message, context, error_);
  if (typeof Sentry !== 'undefined' && typeof Sentry.captureMessage === 'function') {
    Sentry.captureMessage('rationale highlight: ' + message, {level: 'warning', extra: context});
  }
}

function pshAddInputErrorClass(selector, context) {
  if (!selector) {
    // A failure the helper could not point at a field. Reachable: a payer-added row whose key no
    // longer matches an other_options entry is reported with no selector rather than dropped, so the
    // rule still applies. Low frequency, and the payer still gets the message.
    pshReportHighlightProblem('no resolvable input selector for a reported failure', context);
    return;
  }
  try {
    $(selector).addClass('input-error');
  } catch (error) {
    // Defensive: every selector is now composed from database ids. A selector jQuery cannot parse must
    // never abort the rest of submit validation.
    pshReportHighlightProblem('could not highlight ' + selector, context, error);
  }
}

app.service('payerSurveyHelper',
  ['CONSTANTS', 'portalHelper', 'dataConvert', '$filter', '$rootScope',
    'stringHelper', 'minCharsHelper', function (CONSTANTS, portalHelper, dataConvert, $filter, $rootScope,
      stringHelper, minCharsHelper) {
      const payerSurveyHelper = this;

      payerSurveyHelper.submit_survey_confirm = function (is_test_survey, fn_submit_survey, cb_submit_done) {
        let popup_title = 'Submit Survey';
        let popup_text = 'Your response will now be submitted. Do you wish to continue to submit the survey responses?';

        const cur_scope = $rootScope.$new(true);

        if (is_test_survey) {
          popup_title = 'Pilot Testing';
          popup_text = 'Do you wish to complete your pilot survey?';
        }

        cur_scope.confirmed = false;

        portalHelper.showPopupYesNo(
          popup_title,
          popup_text,
          function (scope, button) {
            // Yes callback

            // we set 'Yes' button disabled, and we don't need to enable it,
            // because popup being closed anyway
            button.setDisabled(true);
            cur_scope.confirmed = true;
          },
          function () {
            // No callback

            if (cb_submit_done) {
              cb_submit_done();
            }
          },
          null,
          null,
          function () {
            // destroy callback
            // submit only after popup is destroyed, otherwise scroll does not work!!!

            if (cur_scope.confirmed) {
              // we pass callback, which should enable Submit button, after all processing is done
              // this callback is necessary due to 'multiclick' issue (RPR-1580)

              fn_submit_survey(cb_submit_done, cb_submit_done);
            }
          }
        );
      };

      function toggleRationaleInputError($elements) {
        $elements.each(function (index, item) {
          if (!item.value && item.willValidate) {
            item.classList.add('input-error');
          } else {
            item.classList.remove('input-error');
          }
        });
      }
      function highlightRationaleInputBoxes(question, selector) {
        let $elements;
        switch (question.type) {
          case CONSTANTS.questionTypeIds.CHECK_BOXES:
            // Per-option boxes are suffixed with the option id; the trailing underscore keeps the
            // Other row (..._other_<id>) and the single box (..._single_<id>) out of the match.
            $elements = $('textarea[id^="MainContent_rpt_QuestionsGroups_rpt_Questions_rationaleBox_'
              + question.id + '_"]');
            toggleRationaleInputError($elements);
            break;

          case CONSTANTS.questionTypeIds.RATING:
          case CONSTANTS.questionTypeIds.SLIDER_RATING_SCALE:
          case CONSTANTS.questionTypeIds.POINTS_ALLOCATION:
          case CONSTANTS.questionTypeIds.RADIO_RANKING:
            if (selector) {
              $elements = $(selector);
            } else {
              $elements = $('#question-input-' + question.id + ' .rationale textarea');
            }
            toggleRationaleInputError($elements);
            break;
        }
      }

      function processRationaleField(q, option_id, option_response, i, other_index) {
        if (!q.scale.rationale_mandatory[i]) return false;

        const rationale_field = i === 0 ? 'rationale' : `rationale${i}`;
        let selector;

        // For multiple other options, use other_index-question.id pattern
        if (typeof other_index !== 'undefined' && other_index !== -1) {
          selector = `#question-input-${q.id} .option-${other_index}-${q.id}-${rationale_field}`;
        } else {
          // For regular options, use existing pattern
          selector = `#question-input-${q.id} .option-${option_id}-${rationale_field}`;
        }

        // Always toggle highlight (adds for empty, removes for filled)
        highlightRationaleInputBoxes(q, selector);
        return minCharsHelper.isBlank(option_response[rationale_field]);
      }

      function processOptionResponse(q, option_id, option_response, other_index) {
        if (!option_response?.value) return false;

        let hasError = false;
        const totalRationaleFields = q.scale.more_info_columns_count;
        for (let i = 0; i < totalRationaleFields; i++) {
          if (processRationaleField(q, option_id, option_response, i, other_index)) {
            hasError = true;
          }
        }
        return hasError;
      }

      function validateRationaleFields(q, responses, cur_error_text) {
        // Only used for RATING and RADIO_RANKING questions with multi-rationale
        // Validate multiple rationale fields based on rationale_mandatory array
        let hasError = false;
        for (const option_id in responses) {
          if (processOptionResponse(q, option_id, responses[option_id])) {
            hasError = true;
          }
        }
        if (hasError) {
          return {
            cur_success: false,
            cur_error_text: cur_error_text,
            detailed_message: 'Please complete the highlighted box.'
          };
        }
        return null;
      }

      payerSurveyHelper.validateSingleResponse = function (q, r) {
        let cur_success = true;
        let cur_error_text = '';
        let detailed_message = '';
        const rationale_description = (q.rationale_description) ? q.rationale_description : 'More Information';
        let required_answers, cur_answers;

        // Drop the previous attempt's highlights before any check runs: a box that is now fine must not
        // keep a stale border when this attempt fails an earlier check. Checks below re-flag their own.
        pshClearInputErrors(q.id);

        if (q.type == CONSTANTS.questionTypeIds.FREE_TEXT && minCharsHelper.isBlank(r.response_value)) {
          cur_success = false;
          detailed_message = 'Please enter a response. It cannot be empty.';
        } else if (q.type == CONSTANTS.questionTypeIds.DROPDOWN_LIST && !r.response_value) {
          cur_success = false;
          detailed_message = 'Please select a response from the dropdown menu.';
        } else if ((q.type == CONSTANTS.questionTypeIds.RATING || q.type == CONSTANTS.questionTypeIds.SLIDER_RATING_SCALE) && q.allow_payer_option !== CONSTANTS.otherOptions.MULTIPLE_OTHER) {
          // error check: single other without other value, or other value without other option
          if (q.type == CONSTANTS.questionTypeIds.SLIDER_RATING_SCALE && r.allow_payer_option && r.payer_option && stringHelper.isNullOrEmpty(r.payer_value)) {
            if (stringHelper.isNullOrEmpty(r.non_discrete_payer_value)) {
              cur_success = false;
              cur_error_text = 'Please enter \'Other\' option value.';
            }
          }

          if (r.allow_payer_option && !r.payer_option && r.payer_value) {
            cur_success = false;
            cur_error_text = 'Please enter text in \'Other\' option.';
          }

          if (!r || !r.rating_responses) {
            cur_success = false;
            cur_error_text = 'Please provide an appropriate response.';
            return { 'cur_success': cur_success, 'detailed_message': cur_error_text };
          }

          required_answers = q.options.length;
          cur_answers = Object.keys(r.rating_responses).length;

          if (r.allow_payer_option && r.payer_option) {
            required_answers += 1;
          }

          if (r.allow_payer_option && (!stringHelper.isNullOrEmpty(r.payer_value) || !stringHelper.isNullOrEmpty(r.non_discrete_payer_value))) {
            cur_answers += 1;
          }

          if (!r.rating_responses || required_answers != cur_answers) {
            cur_success = false;
            cur_error_text = 'Please enter text in \'Other\' option.';
          }

          // Validate multiple rationale fields based on rationale_mandatory array
          if (q.type == CONSTANTS.questionTypeIds.RATING && q.scale && q.scale.rationale_mandatory && portalHelper.isMultiRationale(q.rationale_type)) {
            const ratingResult = validateRationaleFields(q, r.rating_responses, cur_error_text);
            if (ratingResult) return ratingResult;
          }

          if (!cur_success && !detailed_message) {
            detailed_message = 'Please rate each item in the list.';
          }
        } else if (q.type == CONSTANTS.questionTypeIds.RATING && q.allow_payer_option == CONSTANTS.otherOptions.MULTIPLE_OTHER) {
          if (r.other_options.length == 0) {
            detailed_message = 'Please add at least one option and rate the option.';
            cur_success = false;
          } else {
            cur_answers = 0;
            required_answers = 0;
            // calculate number of non empty options
            for (let k = 0; k < r.other_options.length; k++) {
              if (r.other_options[k].option_name) {
                required_answers += 1;
              }
            }

            if (!required_answers) {
              cur_success = false;
            } else {
              // calculate number of responses
              for (const option_name in r.rating_responses) {
                if (r.rating_responses[option_name].value) {
                  cur_answers += 1;
                }
              }

              if (required_answers != cur_answers) {
                cur_success = false;
              }
            }
            // Validate multiple rationale fields based on rationale_mandatory array
            if (q.scale && q.scale.rationale_mandatory && portalHelper.isMultiRationale(q.rationale_type)) {
              // Special handling for multiple other options - iterate with other_index
              let hasRationaleError = false;
              for (const option_name in r.rating_responses) {
                const option_response = r.rating_responses[option_name];
                if (!option_response || !option_response.value) continue;

                // Find the other_index for this option_name. A key matching no other_options entry is
                // skipped here on purpose: processRationaleField would fall back to interpolating the
                // key, and a payer-typed name is not a safe jQuery selector. minCharsHelper's
                // firstMandatoryError re-checks the same rule below and reports such a row with a null
                // selector, so the rule is not lost.
                const other_index = r.other_options.findIndex(opt => opt.option_name === option_name);
                if (other_index === -1) continue;

                if (processOptionResponse(q, option_name, option_response, other_index)) {
                  hasRationaleError = true;
                }
              }
              if (hasRationaleError) {
                return {
                  cur_success: false,
                  cur_error_text: cur_error_text,
                  detailed_message: 'Please complete the highlighted box.'
                };
              }
            }

            if (!cur_success && !detailed_message) {
              detailed_message = 'Please rate each item in the list.';
            }
          }
        } else if (q.type == CONSTANTS.questionTypeIds.DRAG_DROP_RANKING) {
          const requiredToRank = q.scale.items_to_rank == null ? q.scale.options.length : q.scale.items_to_rank;

          if (!r.ranking_responses || (requiredToRank !== Object.keys(r.ranking_responses).length)) {
            cur_success = false;
            detailed_message = 'Please drag and rank ' + requiredToRank + ' items.';
          }
        } else if (q.type == CONSTANTS.questionTypeIds.RADIO_RANKING) {
          // error check: single other without other value, or other value without other option
          if (r.allow_payer_option && r.payer_option && stringHelper.isNullOrEmpty(r.payer_value)) {
            cur_success = false;
            detailed_message = 'Please enter \'Other\' option value.';
          }
          if (r.allow_payer_option && !r.payer_option && r.payer_value) {
            cur_success = false;
            detailed_message = 'Please enter text in \'Other\' option.';
          }

          // number of rows can be than number of columns
          // so we compare responses with number of scale.values
          let required_scale_values_count = q.scale.values.length;
          if (q.allow_payer_option && !r.payer_option) {
            required_scale_values_count -= 1;
          }
          let answers_count = r.ranking_responses && Object.keys(r.ranking_responses).length;
          // while taking a pilot survey as admin, since response are not fetched from backend
          // r.allow_payer option is undefined
          // q.allow_payer_option is available both in payer and admin portal
          if (q.allow_payer_option && r.payer_value) {
            answers_count += 1;
          }
          if (!r.ranking_responses || (answers_count < required_scale_values_count)) {
            cur_success = false;
            detailed_message = 'Please assign all the ranks available.';
          }
          if (q.scale && q.scale.rationale_mandatory && portalHelper.isMultiRationale(q.rationale_type)) {
            const rankingResult = validateRationaleFields(q, r.ranking_responses, cur_error_text);
            if (rankingResult) return rankingResult;
          }

        } else if (q.type == CONSTANTS.questionTypeIds.RADIO_BUTTONS) {
          if (!r.response_value && !q.allow_payer_option) {
            // no response
            cur_success = false;
          } else if (!r.response_value && q.allow_payer_option && !r.payer_option) {
            // no response and no other option
            cur_success = false;
          }

          if (!cur_success) {
            detailed_message = 'Please select a response from the list.';
          }

          if (r.payer_option_selected == true && stringHelper.isNullOrEmpty(r.payer_option)) {
            cur_success = false;
            detailed_message = 'Please enter a valid input in the other option textbox.';
          }
        } else if (q.type == CONSTANTS.questionTypeIds.CHECK_BOXES) {
          let count_checked = 0;

          for (const check_name in r.checkbox_responses) {
            if (r.checkbox_responses[check_name]) {
              count_checked += 1;
            }
          }

          if (r.allow_payer_option && r.payer_option) {
            // other checked
            count_checked += 1;
          }

          if (portalHelper.isMultiRationale(q.rationale_type) && r.payer_rationale && !r.payer_option) {
            // other rationale specified without other_option
            cur_success = false;
            cur_error_text = q.text + ', please enter other option or remove more info';
          }

          if (!count_checked) {
            cur_success = false;
            detailed_message = 'Please select at least one response from the list.';
          }

          if (r.payer_option_selected == true && stringHelper.isNullOrEmpty(r.payer_option)) {
            cur_success = false;
            detailed_message = 'Please enter a valid input in the other option textbox.';
          }
        } else if (q.type == CONSTANTS.questionTypeIds.POINTS_ALLOCATION) {
          let total_points = 0;
          let correct_point_count = 0;

          for (const option_id in r.points_allocation_responses) {
            if (r.points_allocation_responses[option_id].points || r.points_allocation_responses[option_id].points == 0) {
              total_points += parseInt(r.points_allocation_responses[option_id].points);
              correct_point_count += 1;
            }
          }

          if (correct_point_count != q.options.length) {
            cur_success = false;
            cur_error_text = q.text + ', all options must be set';
            detailed_message = 'Please allocate points to every row in the list. If you wish to, you can enter a value of 0 (zero).';
          }

          // error check: single other without other value, or other value without other option
          if (r.allow_payer_option && r.payer_option && stringHelper.isNullOrEmpty(r.payer_points)) {
            cur_success = false;
            cur_error_text = 'Please enter \'Other\' option value';
          }
          if (r.allow_payer_option && !r.payer_option && r.payer_points) {
            cur_success = false;
            cur_error_text = 'Please enter text in \'Other\' option';
          }

          if (portalHelper.isMultiRationale(q.rationale_type)
        && r.payer_rationale
        && !r.payer_option
          ) {
            // other rationale specified without other_option
            cur_success = false;
            cur_error_text = q.text + ', please enter other option or remove more info';
          }

          if (cur_success) {
            if (r.payer_points) {
              total_points += parseInt(r.payer_points);
            }

            if (total_points > q.total_points) {
              cur_success = false;
              cur_error_text = q.text + ', all points must add up to ' + q.total_points;
              detailed_message = 'Please decrease your allocation by ' +
            (total_points - q.total_points) +
            ((total_points - q.total_points) == 1 ? ' point' : ' points');
            } else if (total_points < q.total_points) {
              cur_success = false;
              cur_error_text = q.text + ', all points must add up to ' + q.total_points;
              detailed_message = 'Please allocate ' +
            (q.total_points - total_points) +
            ' more ' +
            ((q.total_points - total_points) == 1 ? ' point' : ' points');
            }
          }
        } else if (q.type == CONSTANTS.questionTypeIds.VAN_WESTENDORP_PRICING_MODEL) {

          if (!r.van_westendorp_responses ||
            stringHelper.isNullOrEmpty(r.van_westendorp_responses.acceptable) ||
            stringHelper.isNullOrEmpty(r.van_westendorp_responses.expensive) ||
            stringHelper.isNullOrEmpty(r.van_westendorp_responses.too_expensive) ||
            stringHelper.isNullOrEmpty(r.van_westendorp_responses.prohibitive)) {
            cur_success = false;
            cur_error_text = q.text + ', required field';
            detailed_message = 'Response to all the sub-questions are required.';
          } else {
            if (q.rationale_mandatory && q.rationale_type == 2) {
              if (minCharsHelper.isBlank(r.van_westendorp_responses.rationale_acceptable) ||
                minCharsHelper.isBlank(r.van_westendorp_responses.rationale_expensive) ||
                minCharsHelper.isBlank(r.van_westendorp_responses.rationale_too_expensive) ||
                minCharsHelper.isBlank(r.van_westendorp_responses.rationale_prohibitive)) {
                cur_success = false;
                // cur_error_text = q.text + ", required field";
                $('#question-input-' + q.id + ' .rationale textarea').each(
                  function (index, item) {
                    if (!item.value && item.willValidate) {
                      item.classList.add('input-error');
                    } else {
                      item.classList.remove('input-error');
                    }
                  }
                );
                detailed_message = 'Please complete the highlighted boxes';
              }
            }

            if (q.rationale_mandatory && q.rationale_type == 1) {
              if (minCharsHelper.isBlank(r.rationale)) {
                cur_success = false;
                cur_error_text = q.text + ', required field';
                detailed_message = 'Please complete the \'More Information\' box';
              }
            }

            if (parseFloat(r.van_westendorp_responses.acceptable) >= parseFloat(r.van_westendorp_responses.expensive)) {
              cur_success = false;
              cur_error_text = 'correct 1st or 2nd field';
              detailed_message = 'Please ensure the value of 2nd price point is higher than 1st price point to continue.';

            }

            if (parseFloat(r.van_westendorp_responses.expensive) >= parseFloat(r.van_westendorp_responses.too_expensive)) {
              cur_success = false;
              cur_error_text = 'correct 2nd or 3rd field';
              detailed_message = 'Please ensure the value of 3rd price point is higher than 2nd price point to continue.';
            }

            if (parseFloat(r.van_westendorp_responses.too_expensive) >= parseFloat(r.van_westendorp_responses.prohibitive)) {
              cur_success = false;
              cur_error_text = 'correct 2nd or 3rd field';
              detailed_message = 'Please ensure the value of 4th price point is higher than 3rd price point to continue.';
            }

            if (parseFloat(r.van_westendorp_responses.acceptable) > 99999999.99 ||
              parseFloat(r.van_westendorp_responses.expensive) > 99999999.99 ||
              parseFloat(r.van_westendorp_responses.too_expensive) > 99999999.99 ||
              parseFloat(r.van_westendorp_responses.prohibitive) > 99999999.99) {
              cur_success = false;
              cur_error_text = q.text + ', value should be less than 100000000';
              detailed_message = 'Value of all the sub questions should be less than 100000000';
            }

            if (parseFloat(r.van_westendorp_responses.acceptable) <= 0 ||
              parseFloat(r.van_westendorp_responses.expensive) <= 0 ||
              parseFloat(r.van_westendorp_responses.too_expensive) <= 0 ||
              parseFloat(r.van_westendorp_responses.prohibitive) <= 0) {
              cur_success = false;
              cur_error_text = q.text + ', value should be greater than 0';
              detailed_message = 'Value of all the sub questions should be greater than 0';
            }
          }
        } else if (q.type == CONSTANTS.questionTypeIds.GABOR_GRANGER_PRICING_MODEL) {
          if (q.subquestion == undefined || q.subquestion.is_last !== true) {
            cur_success = false;
            cur_error_text = q.text + ', please complete this question before proceeding';
            detailed_message = 'Please answer this question to proceed';
          }
        }

        // check mandatory multiple rationales. Skipped where a stored per-column config owns the
        // rule, matching the backend's _has_per_column_mandatory_config stand-down: this sweep only
        // ever looks at column 0, so it would block a blank column 0 that the config leaves optional.
        if (cur_success && CONSTANTS.multiRationaleQuestions.indexOf(q.type) > -1 &&
          portalHelper.isMultiRationale(q.rationale_type) && q.rationale_mandatory
          && !minCharsHelper.hasPerColumnMandatoryConfig(q)) {

          let response_options = {};
          if (q.type == CONSTANTS.questionTypeIds.CHECK_BOXES) {
            response_options = r.checkbox_responses;
          } else if (q.type == CONSTANTS.questionTypeIds.RATING) {
            response_options = r.rating_responses;
          } else if (q.type == CONSTANTS.questionTypeIds.SLIDER_RATING_SCALE) {
            response_options = r.rating_responses;
          } else if (q.type == CONSTANTS.questionTypeIds.POINTS_ALLOCATION) {
            response_options = r.points_allocation_responses;
          } else if (q.type == CONSTANTS.questionTypeIds.RADIO_RANKING) {
            response_options = r.ranking_responses;
          }


          for (const check_name in response_options) {
            // Trimmed to match the backend's mandatory sweep: a minimum never fails a blank box, so
            // whitespace here would otherwise pass the client and 400 at the API.
            if (minCharsHelper.isBlank(response_options[check_name].rationale)) {
              cur_success = false;
              detailed_message = 'Please complete the highlighted boxes.';
            }
            highlightRationaleInputBoxes(q);
          }

          if (q.allow_payer_option == CONSTANTS.otherOptions.SINGLE_OTHER
            && r.payer_option && minCharsHelper.isBlank(r.payer_rationale)) {
            cur_success = false;
            if (q.payer_option_rationale_description) {
              detailed_message = 'Please complete the \'' + q.payer_option_rationale_description + '\' box';
            } else {
              detailed_message = 'Please complete the More information box for the \'Other\' option';
            }
          }
        }

        // check mandatory rationale with more information box with each row and single other option
        const isRatingOrRanking = (q.type == CONSTANTS.questionTypeIds.RATING || q.type == CONSTANTS.questionTypeIds.RADIO_RANKING);
        if (cur_success && isRatingOrRanking &&
          portalHelper.isMultiRationale(q.rationale_type) && q.allow_payer_option == CONSTANTS.otherOptions.SINGLE_OTHER) {
          if (r.payer_option && q.scale && q.scale.numberOfMoreInfoColumns && q.scale.numberOfMoreInfoColumns > 1){
            const numberOfColumns = q.scale.numberOfMoreInfoColumns;
            const missingRationaleFields = [];
            for (let i = 0; i < numberOfColumns; i++) {
              if (q.scale.rationale_mandatory && i in q.scale.rationale_mandatory && q.scale.rationale_mandatory[i] === true) {

                const rationaleField = i === 0 ? 'payer_rationale' : 'payer_rationale' + i;
                const rationaleValue = r[rationaleField];

                if (minCharsHelper.isBlank(rationaleValue)) {
                  missingRationaleFields.push(i);
                  // Only highlight the specific missing field
                  const selector = '#question-input-' + q.id + ' .payer-option-rationale-' + i;
                  highlightRationaleInputBoxes(q, selector);
                }
              }
            }

            if (missingRationaleFields.length > 0) {
              cur_success = false;
              if (q.payer_option_rationale_description) {
                detailed_message = 'Please complete the \'' + q.payer_option_rationale_description + '\' box';
              } else {
                detailed_message = 'Please complete the More information box for the \'Other\' option';
              }
            }
          }
        }

        // check manatory single rationale
        if (cur_success && CONSTANTS.singleRationaleQuestions.indexOf(q.type) > -1 && portalHelper.isSingleRationale(
          q.rationale_type) && q.rationale_mandatory) {
          if (minCharsHelper.isBlank(r.rationale)) {
            cur_success = false;
            detailed_message = 'Please complete the \'' + rationale_description + '\' box';
            $('#MainContent_rpt_QuestionsGroups_rpt_Questions_rationaleBox_single_' + q.id).addClass(
              'input-error');
          }
        }

        // Mandatory more-info columns, then minimum characters (which only check boxes the payer typed in).
        if (cur_success) {
          // The mandatory sweeps above highlight every blank box under the question, including columns
          // nothing requires; with the question otherwise valid only a minimum may still highlight one.
          pshClearInputErrors(q.id);
          const minCharsFailure = minCharsHelper.firstError(q, r);
          if (minCharsFailure) {
            cur_success = false;
            detailed_message = minCharsFailure.message;
            if (!minCharsFailure.selfHighlighting) {
              pshAddInputErrorClass(minCharsFailure.selector, {
                questionId: q.id,
                questionType: q.type,
                message: minCharsFailure.message
              });
            }
          }
        }

        // default error text
        if (!cur_success && !cur_error_text) {
          cur_error_text = q.text;
        }

        const res = {};
        res.cur_success = cur_success;
        res.cur_error_text = cur_error_text;
        res.detailed_message = detailed_message;

        return res;
      };

      // If a layoutElement is passed, This function will validate only that question
      // otherwise, all questions will be validated.
      payerSurveyHelper.validate_questions = function (scope, layoutElement) {
        scope.error_list = [];

        let success = true;
        const data = [];
        let total_questions = 0;
        let detail_error_message = '';

        const layoutElements = (layoutElement) ? [layoutElement] : scope.layout;

        for (let i = 0; i < layoutElements.length; i++) {
          if (layoutElements[i].question) {
            total_questions += 1;
            const question_number = total_questions; //(i1+1)
            const error_prefix = question_number + '. ';

            let cur_success = true;
            let cur_error_text = '';
            let q = layoutElements[i].element;

            if (q == null) {
              // By default, pick up the question from the element.
              // If not found, search in list of scope questions
              q = _.findWhere(scope.questions, { id: layoutElements[i].question });
            }

            let r = null;

            if (Object.prototype.hasOwnProperty.call(scope.responses, q.id)) {
              r = scope.responses[q.id];
            } else if (Object.prototype.hasOwnProperty.call(scope.responses_new, q.id)) {
              r = scope.responses_new[q.id];
            }

            if (!r) {
              cur_success = false;
            } else {
              // check that necessary responses filled in for all question types
              const res = payerSurveyHelper.validateSingleResponse(q, r);
              cur_success = res.cur_success;
              cur_error_text = error_prefix + res.cur_error_text;
              detail_error_message = res.detailed_message;
            }

            let qNum = layoutElements[i].number_label;
            if (qNum == null || qNum == '') {
              qNum = question_number;
            }

            // Check in validations if this question is complete
            // (Currently validation works only for TOR2)
            if (scope.response_validations != null &&
            scope.response_validations[q.id] === false) {
              cur_success = false;

              if (q.type === CONSTANTS.questionTypeIds.TABLE_OF_RESPONSES_2) {
                detail_error_message =
                'Please complete all the highlighted sections before you submit the survey.';
              }
            }

            if (!cur_success) {
              success = false;
              scope.error_list.push({
                errorMessage: 'Question ' + qNum + ':',
                questionId: q.id,
                detailMessage: detail_error_message,
                layoutElement: layoutElements[i]
              });
            }
          }
        }

        return success;
      };

      payerSurveyHelper.updateAllResponsesFromServer = function (scope, server_responses) {
        //
        // this function generates 2 dictionaries:
        // 'responses' and 'responses_new'
        //
        // responses - all existing responses from server, will be saved to 'scope.responses'
        // other not found responses will be saved to 'scope.responses_new'
        //
        // P.S.
        // responses are dictionaries on frontend and lists on backend
        //

        const response_new = [];

        for (let i = 0; i < scope.questions.length; i++) {
          const question = scope.questions[i];
          let response = $filter('filter')(server_responses, { 'question': question.id });

          if (question.type == CONSTANTS.questionTypeIds.DRAG_DROP_RANKING) {
            response = (response.length) ? response[0] : {
              'ranking_responses': [],
              'question': question.id
            };
          } else {
            response = (response.length) ? response[0] : { 'question': question.id };
          }

          // if response does not exist, add to response_new
          if (!response.id) {
            response_new.push(response);
          }

          if (question.type == CONSTANTS.questionTypeIds.DRAG_DROP_RANKING) {
            dataConvert.initRankingResponsesSaved(response, question);
            dataConvert.initRankingResponsesNotSaved(response, question);
          }
        }

        dataConvert.convertMultipleResponseOptions(scope.questions, server_responses);
        // this is only because of ranking
        dataConvert.convertMultipleResponseOptions(scope.questions, response_new);

        scope.responses_new = dataConvert.convert_to_dict(response_new, 'question');

        // Add payer_option_selected to each response to track `other` check boxes and radio options
        portalHelper.populatePayerOptionSelected(server_responses);

        scope.responses = dataConvert.convert_to_dict(server_responses, 'question');

        // update flag, since data reloaded:
        scope.data_loaded_time = new Date().getTime();
      };

      payerSurveyHelper.getResponses = function (scope, question_id) {
        if (Object.prototype.hasOwnProperty.call(scope.responses, question_id)) {
          return scope.responses;
        } else {
          return scope.responses_new;
        }
      };

      /** *
   * Constructs a dictionary of question IDs to be used for components to report their own
   * validations. (Currently only supported for TOR2).
   * @param questions {Array<Object>}
   * @return {{}}
   */
      payerSurveyHelper.construct_response_validation_dictionary = function (questions) {
        const result = {};

        for (let i=0; i<questions.length; i++) {
          result[questions[i].id] = null;
        }

        return result;
      };


      payerSurveyHelper.generate_config_with_sub_session = function (includeTimeout, sub_session_id) {
        const responseConfig = {
          headers: {}
        };
        responseConfig.headers[CONSTANTS.SUB_SESSION_HEADER_KEY] = sub_session_id;

        if (includeTimeout) {
          responseConfig['timeout'] = CONSTANTS.REQUEST_TIMEOUT;
        }

        return responseConfig;
      };

    }]
);
